<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import type { DataTableCellProps } from './templateTypes';

const { t } = useI18n();

const cashIcon = `mdi mdi-cash sey-icon mr-1`;
const cashOutIcon = `mdi mdi-cash-register sey-icon mr-1`;

const _props = defineProps<DataTableCellProps>();
</script>

<template>
  <ExpandableCell v-if="cell.meta('rawvalue').length > 0" :data-key="dataKey" :field="column.field">
    <!-- Collapsed content -->
    <template #collapsed>
      <div class="space-y-1">
        <div class="flex gap-2">
          <div class="font-semibold truncate">
            <span :class="cashIcon" />{{ t(`labels.payment`) }}
          </div>
          <div class="flex">
            {{ cell.meta('rawvalue')[0]?.amount }} {{ cell.meta('rawvalue')[0]?.currency }} [...]
          </div>
        </div>
      </div>
    </template>

    <!-- Expanded content -->
    <template #expanded>
      <div
        v-for="(arrayValue, arrayIndex) in cell.meta('rawvalue')"
        :key="arrayIndex"
        class="space-y-1 mb-4"
      >
        <div class="flex gap-2">
          <div class="font-semibold w-32 truncate">
            <span :class="cashIcon" />{{ t(`labels.payment`) }}
          </div>
          <div class="flex-1">{{ arrayValue.amount }} {{ arrayValue.currency }}</div>
        </div>
        <div class="flex gap-2">
          <div class="font-semibold w-32 truncate">
            <span :class="cashOutIcon" />{{ t(`labels.paymentType`) }}
          </div>
          <div class="flex-1">{{ t(`enums.${arrayValue.paymentType.toUpperCase()}`) }}</div>
        </div>
      </div>
    </template>
  </ExpandableCell>
</template>
